<section class="evolution-chart-card">
  <header class="chart-head">
    <div class="chart-head-copy">
      <h3>{{ title }}</h3>
      @if (subtitle) {
        <p>{{ subtitle }}</p>
      }
    </div>
    @if (currentValue !== null) {
      <div class="chart-current-value">
        <span>Ahora</span>
        <strong>{{ currentValueLabel }}</strong>
      </div>
    }
  </header>

  @if (groups.length > 0) {
    <div class="chart-group-selector">
      <button
        type="button"
        [class.active]="selectedGroup === 'general'"
        (click)="selectedGroupChange.emit('general')"
      >
        General
      </button>
      @for (group of groups; track group._id) {
        <button
          type="button"
          [class.active]="selectedGroup === group._id"
          (click)="selectedGroupChange.emit(group._id)"
        >
          {{ group.name }}
        </button>
      }
    </div>
  }

  @if (hasData()) {
    <div class="chart-canvas-wrap">
      <canvas #chartCanvas></canvas>
    </div>
  } @else {
    <div class="chart-empty">
      <span>No hay suficientes datos todavía para mostrar la evolución.</span>
    </div>
  }
</section>
